<template>
  <div class="aviso-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1 class="text-h4 mb-4">Aviso Legal</h1>

          <h2 class="text-h6 mt-6 mb-3">Identificación del responsable</h2>
          <p>
            <strong>Titular:</strong> MARIO ANDERSON PUMA ACHULLA<br />
            <strong>RUC:</strong> 10459898676<br />
            <strong>Domicilio fiscal:</strong> AV. MESETA DE COLLAO DEL COLLAO MZ.N
            LOTE.26 A.H.EDILBERTO RAMOS, Villa El Salvador, Lima, Perú<br />
            <strong>Correo electrónico:</strong> informes@consultora-innova.com<br />
            <strong>Sitio web:</strong> https://consultora-innova.com
          </p>

          <h2 class="text-h6 mt-6 mb-3">Condiciones de uso</h2>
          <p>
            El acceso y uso de este sitio web implica la aceptación plena de las
            condiciones aquí establecidas. Si no está de acuerdo con estas condiciones, no
            debe utilizar este sitio.
          </p>
          <p>
            Consultora Innova se reserva el derecho a modificar en cualquier momento las
            condiciones de uso del sitio, así como los contenidos y servicios ofrecidos.
          </p>

          <h2 class="text-h6 mt-6 mb-3">Propiedad intelectual</h2>
          <p>
            Todos los contenidos, textos, imágenes, logotipos, código fuente y demás
            elementos presentes en este sitio web son propiedad de Consultora Innova o de
            terceros que han autorizado su uso, y están protegidos por las leyes de
            propiedad intelectual aplicables.
          </p>
          <p>
            Queda prohibida la reproducción, distribución, modificación o comunicación
            pública de los contenidos sin autorización expresa del titular.
          </p>

          <h2 class="text-h6 mt-6 mb-3">Exclusión de responsabilidad</h2>
          <p>Consultora Innova no se hace responsable de:</p>
          <ul>
            <li>Los daños que pudieran derivarse del uso de este sitio web.</li>
            <li>El contenido de los sitios web enlazados desde este portal.</li>
            <li>
              Interrupciones o errores en el acceso al sitio por causas ajenas a la
              empresa.
            </li>
          </ul>

          <h2 class="text-h6 mt-6 mb-3">Legislación aplicable</h2>
          <p>
            Este aviso legal se rige por la legislación peruana. Cualquier controversia
            que surja en relación con este sitio web será resuelta ante los juzgados y
            tribunales de Lima, Perú.
          </p>

          <h2 class="text-h6 mt-6 mb-3">Protección de datos</h2>
          <p>
            Para conocer cómo tratamos sus datos personales, consulte nuestra
            <router-link to="/privacidad">Política de Privacidad</router-link>.
          </p>

          <v-divider class="my-6"></v-divider>
          <p class="text-center text-caption">
            © 2026 Consultora Innova - Todos los derechos reservados
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AvisoLegal",
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.aviso-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
}
a {
  color: #1976d2;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>
